/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseenteravalidminimumprice5Inputs */

const en_pleaseenteravalidminimumprice5 = /** @type {(inputs: Pleaseenteravalidminimumprice5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid minimum price`)
};

const de_pleaseenteravalidminimumprice5 = /** @type {(inputs: Pleaseenteravalidminimumprice5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib einen gültigen Mindestpreis ein`)
};

/**
* | output |
* | --- |
* | "Please enter a valid minimum price" |
*
* @param {Pleaseenteravalidminimumprice5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseenteravalidminimumprice5 = /** @type {((inputs?: Pleaseenteravalidminimumprice5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseenteravalidminimumprice5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseenteravalidminimumprice5(inputs)
	return de_pleaseenteravalidminimumprice5(inputs)
});
export { pleaseenteravalidminimumprice5 as "pleaseEnterAValidMinimumPrice" }